import React, { useEffect, useState } from "react";
import { findIcon } from "../../../../../dashboard/icons";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useGetSummaryLeadsUserEngagementById } from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import { useParams } from "react-router-dom";
import useBackdrop from "../../../../../../components/custom-hooks/use-backdrop";
import ReactPlayer from "react-player";

const UserEngagementTimeline = ({
  title = "",
  leadsUserEngagement = [],
  engagementPayload,
}) => {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <div className="header-title">
          <h5 className="card-title subHeadingLeft position-relative mb-3">
            {title}
          </h5>
        </div>
      </div>
      <div className="card-body">
        <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
          <ul className="list-inline p-0 m-0 w-100">
            {leadsUserEngagement?.map((data, index) => {
              const collapseId = `collapse_${index}-${data?.engagement_id}`;
              return (
                <UserEngagementTimelinePreview
                  key={collapseId}
                  data={data}
                  collapseId={collapseId}
                  engagementPayload={engagementPayload}
                />
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

const UserEngagementTimelinePreview = ({
  data,
  collapseId,
  engagementPayload,
  index,
}) => {
  const { project_id, leads_id } = useParams();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const [engagementId, setEngagementId] = useState("");

  const { data: engagementDetails, isLoading: isEngagementDetailsLoading } =
    useGetSummaryLeadsUserEngagementById(
      project_id,
      leads_id,
      engagementId,
      engagementPayload
    );

  useEffect(() => {
    if (!!engagementId && isEngagementDetailsLoading) {
      showBackdrop();
    } else {
      hideBackdrop();
    }
  }, [isEngagementDetailsLoading, engagementId]);

  const getTimelineIcon = (content_type) => {
    switch (content_type) {
      case "banner_data":
        return findIcon("content-interaction-outline", "outline", "20");
      case "archiveVideoDetail":
        return findIcon("video-outline", "outline", "20");
      case "feedDetail":
        return findIcon("cme-registration-outline", "outline", "20");
      case "sessiondetail_new":
        return findIcon("card-content-outline", "outline", "20");
      // case "cme_registration":
      //   return findIcon("content-interaction-outline", "outline", "20");
      default:
        return findIcon("schedule-outline", "outline", "20");
    }
  };

  const getEngagementButtonText = (content_type) => {
    switch (content_type) {
      case "sessiondetail_new":
        return "Session View";
      case "archiveVideoDetail":
        return "Clinical Video View";
      case "feedDetail":
        return "MedWiki View";
      case "banner_data":
        return "Banner View";
      default:
        return "Click";
    }
  };

  const getEngagementColorScheme = (content_type, type = "") => {
    switch (content_type) {
      case "banner_data":
        return type === "bg" ? "primary-light" : "primary";
      case "archiveVideoDetail":
        return "success";
      case "feedDetail":
        return "danger";
      case "sessiondetail_new":
        return "success";
      default:
        return "black";
    }
  };
  const renderFilePreview = (url, title) => {
    const fileType = getFileType(url);

    switch (fileType) {
      case "image":
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <img
              src={url}
              alt={"Image"}
              style={{ width: "30rem", height: "auto" }}
            />
          </a>
        );
      case "video":
        return (
          <ReactPlayer url={url} controls={true} playing={false} light={url} />
        );
      case "audio":
        return (
          <audio controls>
            <source src={url} type="audio/mp3" />
            Your browser does not support the audio tag.
          </audio>
        );
      case "pdf":
        return (
          <iframe
            src={url}
            width="100%"
            height="500px"
            style={{ border: "none" }}
            title={title}
          />
        );
      case "document":
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Open Document
          </a>
        );
      default:
        return <p>Unsupported file type</p>;
    }
  };

  const downloadFile = async (fileUrl = "") => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileUrl.split("/").pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectUrl);
      toast.success("File has been downloaded successfully!");
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Download failed!");
    }
  };

  const handleCollapseClick = (engagement_id) => {
    setEngagementId(engagement_id);
  };
  const getFileType = (url) => {
    if (!url) return "unknown";
    const extension = url.split(".").pop().split("?")[0].toLowerCase();
    const imageTypes = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "m3u8"];
    const audioTypes = ["mp3", "wav", "ogg", "aac", "flac"];
    const pdfTypes = ["pdf"];
    const docTypes = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
    if (imageTypes.includes(extension)) return "image";
    if (videoTypes.includes(extension)) return "video";
    if (audioTypes.includes(extension)) return "audio";
    if (pdfTypes.includes(extension)) return "pdf";
    if (docTypes.includes(extension)) return "document";

    return "unknown";
  };

  return (
    <li key={`user_engagement_${index}`} className="w-100">
      <div className="d-flex justify-content-between w-100">
        <div>
          <div
            className={`timeline-dots1 border-0 text-${getEngagementColorScheme(
              data?.engagement_type || "default"
            )}`}
            style={{
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
          >
            {getTimelineIcon(data?.engagement_type || "default")}
          </div>
          <h6 className="mb-3 fw-semibold text-capitalize">
            Content Interaction
          </h6>
          <div className="d-flex gap-2 flex-wrap">
            <p
              className={`badge border border-${getEngagementColorScheme(
                data?.engagement_type || "default"
              )} text-${getEngagementColorScheme(
                data?.engagement_type || "default"
              )} rounded-pill d-flex align-items-center gap-1 px-3 py-2 fs-6 bg-${getEngagementColorScheme(
                data?.engagement_type || "default",
                "bg"
              )} bg-opacity-10`}
              data-bs-toggle="collapse"
              data-bs-target={`#${collapseId}`}
              aria-expanded="false"
              aria-controls={collapseId}
              style={{ cursor: "pointer" }}
              onClick={() => handleCollapseClick(data?.engagement_id)}
            >
              <i>{findIcon("chevron_right", "solid", "20")} </i>
              {getEngagementButtonText(data?.engagement_type || "default")}
            </p>

            {/* FIXME: correct key need, where I can get the video */}
            {data?.engagement_title === "video" && (
              <p
                onClick={() => downloadFile(data?.link)}
                className="badge border border-primary text-white bg-primary rounded-pill d-flex align-items-center gap-1 px-3 py-1 fs-6"
              >
                <i>{findIcon("Arrow Box Down", "outline", "20")}</i>
                Download
              </p>
            )}
          </div>
        </div>
        <div>
          <p className="m-0 p-0">
            {dayjs(data?.timestamp).format("DD MMM, YYYY")}
          </p>
        </div>
      </div>

      <div id={collapseId} className="collapse mt-2 w-100">
        {engagementDetails?.at(0)?.content_data?.map((eggData, index) => {
          return (
            <div
              className="w-50 card p-3 rounded-3"
              key={"user_engagement_" + eggData?.type_id}
            >
              <div className="w-100 bg-dark text-center rounded-3 d-flex justify-content-center flex-shrink-0 overflow-hidden">
                {renderFilePreview(eggData.cover_img, eggData?.title)}
              </div>
              {eggData?.title && (
                <h6 className="mt-3 mb-2 fw-semibold one-line-clamp">
                  {eggData?.title}
                </h6>
              )}
              {eggData?.description && (
                <p className="two-line-clamp">{eggData?.description}</p>
              )}
            </div>
          );
        })}
      </div>
    </li>
  );
};

export default UserEngagementTimeline;
